import { render, staticRenderFns } from "./BrandingSetting.vue?vue&type=template&id=9cd51eee&scoped=true"
import script from "./BrandingSetting.vue?vue&type=script&lang=js"
export * from "./BrandingSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd51eee",
  null
  
)

export default component.exports